/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface PostUniverseNamesNotFound
 */
export interface PostUniverseNamesNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof PostUniverseNamesNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the PostUniverseNamesNotFound interface.
 */
export function instanceOfPostUniverseNamesNotFound(value: object): value is PostUniverseNamesNotFound {
    return true;
}

export function PostUniverseNamesNotFoundFromJSON(json: any): PostUniverseNamesNotFound {
    return PostUniverseNamesNotFoundFromJSONTyped(json, false);
}

export function PostUniverseNamesNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseNamesNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostUniverseNamesNotFoundToJSON(json: any): PostUniverseNamesNotFound {
    return PostUniverseNamesNotFoundToJSONTyped(json, false);
}

export function PostUniverseNamesNotFoundToJSONTyped(value?: PostUniverseNamesNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

